import React from 'react';
import { map } from 'lodash';
import { Grid, Divider, Button } from 'semantic-ui-react';
import withDataFetch from '../../api/withDataFetch';
import withFullScreenLoading from '../UtilityComponents/withFullScreenLoading';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import './Jobs.css';

const Jobs = ({
  data: {
    title,
    subtitle,
    text,
    options,
  },
}) => {
  return (
    <Grid stackable className="Company">
      <Grid.Row columns="equal" centered>
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />

      <Grid.Row>
        {renderDataAsHtml(subtitle)}
      </Grid.Row>
      <Divider />
      <Grid.Row width={16}>
        {renderDataAsHtml(text)}
      </Grid.Row>
      {map(options, ({ job_document: doc, job_description: description }) => {
        return (
          <Grid.Row width={16}>
            <div className="Jobs__Options">
              {renderDataAsHtml(description)}
              <a href={doc.url} download className="Jobs__Download" target="_blank" rel="noopener noreferrer">
                <Button className="btn-animated">
                Download vacature
                </Button>
              </a>
            </div>
          </Grid.Row>
        );
      })}
      <Divider />
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoading(Jobs), 'vacatures');



// WEBPACK FOOTER //
// ./src/components/Jobs/index.js